export enum LoginScreen {
  LOGIN = "LOGIN",
  ENTER_OTP = "ENTER_OTP",
  SETUP_OTP = "SETUP_OTP",
}
